import React from 'react'
import { isNil, isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import Component from '../common/Component'
import SharedBusinessRulesPriorityModal from './SharedBusinessRulesPriorityModal'
import SharedBusinessRulesTable from './SharedBusinessRulesTable'
import { SharedBusinessRulesIndex } from './SharedBusinessRulesIndex'

export class SharedBusinessRulesComponent extends Component {
  static propTypes = {
    records: PropTypes.object,
    handleDateChange: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      effectiveDate: (new Date()).toISOString().split('T')[0],
      displayPriorityModal: false,
      displayModalRuleType: ''
    }
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handelRulePriorityModal = this.handelRulePriorityModal.bind(this)
  }

  handlePriorityClose = () => {
    this.setState({ displayPriorityModal: false, displayModalRuleType: '' })
  }

  handleDateChange(event) {
    this.setState({
      effectiveDate: event.target.value
    })

    this.props.handleDateChange(event.target.value)
  }

  get columns() {
    return SharedBusinessRulesIndex.columns.filter(
      (column) => ['shared_business_rule_type', 'payload', 'matching_type'].includes(column.key)
    )
  }

  get modalColumns() {
    return SharedBusinessRulesIndex.columns.filter(
      (column) => ['vericred_id', 'payload', 'matching_type', 'matching_data'].includes(column.key)
    ).concat({ key: 'priority_status', label: 'Status', sortable: false })
  }

  /* eslint-disable no-param-reassign */
  get priorityModal() {
    if (this.state.displayPriorityModal !== true && isEmpty(this.state.displayModalRuleType)) {
      return null
    }

    const prioritizedRecords = this.props.records.business_rules[this.state.displayModalRuleType]
      .map((record, index) => {
        record.priority_status = ''
        if (index === 0) {
          record.priority_status = 'Active'
        }
        return record
      })

    return (
      <SharedBusinessRulesPriorityModal
        columns={this.modalColumns}
        records={prioritizedRecords}
        ruleType={this.state.displayModalRuleType}
        handleClose={this.handlePriorityClose}
      />
    )
  }
  /* eslint-enable no-param-reassign */

  get content() {
    const {
      records
    } = this.props

    if (isNil(records)) {
      return null
    }

    const highestPriorityRules = Object.keys(records.business_rules).map((key) => records.business_rules[key][0])

    return (
      <div> {this.businessRulesTable(highestPriorityRules)}
        {this.priorityModal}
      </div>
    )
  }

  handelRulePriorityModal(event, businessRuleType) {
    event.preventDefault()

    this.setState({ displayPriorityModal: true, displayModalRuleType: businessRuleType })
  }

  businessRulesTable(records) {
    return (
      <SharedBusinessRulesTable
        records={records}
        columns={this.columns}
        filtered
        handelRulePriorityModal={this.handelRulePriorityModal}
      />
    )
  }

  render() {
    return (
      <div className="content">
        <h5>Search for an Effective Date to see Business Rules</h5>
        <div className="field">
          <input
            className="pure-input-1"
            name="effectiveDate"
            type="date"
            onChange={this.handleDateChange}
            value={this.state.effectiveDate}
          />
        </div>
        <br />
        {this.content}
      </div>
    )
  }
}

export default SharedBusinessRulesComponent
